import { __read } from 'tslib';
import React__default, { useState, useEffect } from 'react';

var style = {
    alignItems: 'center',
    backgroundColor: 'red',
    color: 'yellow',
    cursor: 'pointer',
    display: 'flex',
    flexDirection: 'column',
    fontSize: 24,
    justifyContent: 'center',
    padding: 48,
    width: '100%',
};
var collapseStyle = {
    background: '#eee',
    color: 'black',
    fontSize: 14,
    lineHeight: 1,
    marginTop: 12,
    padding: 10,
};
var FallbackComponent = function (_a) {
    var error = _a.error;
    var _b = __read(useState(false), 2), isOpen = _b[0], setIsOpen = _b[1];
    var _c = __read(useState(true), 2), isProduction = _c[0], setIsProduction = _c[1];
    useEffect(function () {
        var _a;
        if (!((_a = window === null || window === void 0 ? void 0 : window.location) === null || _a === void 0 ? void 0 : _a.hostname))
            return;
        var urlIsProduction = window.location.hostname.includes('invitae.com');
        setIsProduction(urlIsProduction);
    }, []);
    return isProduction ? (React__default.createElement("div", { dangerouslySetInnerHTML: {
            __html: "\n        <!-- \n          Failed to render component\n\n          ".concat(error === null || error === void 0 ? void 0 : error.stack, " \n        -->\n      "),
        } })) : (React__default.createElement("div", { onClick: function () { return setIsOpen(function (prev) { return !prev; }); }, style: style },
        React__default.createElement("div", null,
            "Failed to render component: ", error === null || error === void 0 ? void 0 :
            error.message),
        isOpen && React__default.createElement("div", { style: collapseStyle }, error === null || error === void 0 ? void 0 : error.stack)));
};

export { FallbackComponent as default };
//# sourceMappingURL=FallbackComponent.esm.js.map
